import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ErrorState } from '@mkcore/ui';

class NoAccess extends Error {}

// Admin pages need admin:read; the page shows a clear message, the server stays the real check.
export const Route = createFileRoute('/_app/admin')({
  beforeLoad: ({ context }) => {
    const me = (context as unknown as { me: { permissions: string[] } }).me;
    if (!me.permissions.includes('admin:read')) throw new NoAccess();
  },
  errorComponent: AdminError,
  component: () => <Outlet />,
});

function AdminError({ error }: { error: unknown }) {
  const { t } = useTranslation();
  if (error instanceof NoAccess) return <ErrorState title={t('errors.noAccess')} description={t('errors.noAccessText')} />;
  return <ErrorState title={t('errors.generic')} description={error instanceof Error ? error.message : undefined} />;
}
